import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "search-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.0269 17.0876C14.6767 18.2014 12.946 18.8705 11.059 18.8705C6.7446 18.8705 3.24707 15.3729 3.24707 11.0585C3.24707 6.74411 6.7446 3.24658 11.059 3.24658C15.3734 3.24658 18.871 6.74411 18.871 11.0585C18.871 12.9458 18.2017 14.6767 17.0876 16.027L20.5337 19.4731C20.8266 19.766 20.8266 20.2408 20.5337 20.5337C20.2408 20.8266 19.766 20.8266 19.4731 20.5337L16.0269 17.0876ZM4.74707 11.0585C4.74707 7.57253 7.57302 4.74658 11.059 4.74658C14.545 4.74658 17.371 7.57253 17.371 11.0585C17.371 12.7899 16.6739 14.3584 15.5451 15.4988C15.5371 15.5061 15.5292 15.5137 15.5214 15.5214C15.5137 15.5292 15.5061 15.537 15.4988 15.545C14.3585 16.6736 12.7901 17.3705 11.059 17.3705C7.57302 17.3705 4.74707 14.5445 4.74707 11.0585Z"
    }, null, -1)
  ])))
}
export default { render: render }